module.exports = __webpack_public_path__ + "media/components/lesson1/common/statics/workspace_empty-4b8647b91076b5848074761427996a90.png";